<mat-toolbar class="stick-top">
  <mat-icon>search</mat-icon>
  Find Asset
</mat-toolbar>
<div class="hbox lightly-padded button-bar">
  <button mat-raised-button class="primary" type="button" (click)="find()" [disabled]="!itsmCarrierId || !form.form.valid">
    Find
  </button>
</div>

<div class="padded vbox vbox-space">
  <div>
    <form #form="ngForm" role="form">
      <table class="basicTable">
        <thead>
        <tr>
          <th colspan="100">Find Asset</th>
        </tr>
        <tr>
          <th style="width: 200px;">Carrier</th>
          <th>CI-Name</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <micro-itsmCarrier-select [(itsmCarrierId)]="itsmCarrierId" [required]="true"></micro-itsmCarrier-select>
          </td>
          <td>
            <input [(ngModel)]="name" required placeholder="CI-Name" id="name" name="name">
          </td>
        </tr>
        </tbody>
      </table>
    </form>
  </div>

  <div *ngIf="asset">
    <table class="basicTable">
      <thead>
      <tr>
        <th colspan="100">Asset Detail</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <th>CI-Name</th><td>{{asset.name}}</td>
      </tr>
      <tr>
      <tr>
        <th>Product</th><td>{{asset.product}}</td>
      </tr>
      <tr>
        <th>Product Type</th><td>{{asset.productType}}</td>
      </tr>
      <tr>
      </tbody>
    </table>
  </div>
</div>


